module.exports = __webpack_public_path__ + "static/img/frontPage2.01962410.jpg";